// src/components/Sidebar/hooks/useLastBoardCategory.js
import { useEffect, useState } from "react";

const STORAGE_KEY = "lastBoardCategory";

export default function useLastBoardCategory(locationSearch) {
    const [lastCat, setLastCat] = useState(() => localStorage.getItem(STORAGE_KEY));

    useEffect(() => {
        const current = new URLSearchParams(locationSearch).get("category");
        if (current) {
            setLastCat(current);
            localStorage.setItem(STORAGE_KEY, current);
        }
    }, [locationSearch]);

    const setAndStore = (id) => {
        const v = String(id);
        setLastCat(v);
        localStorage.setItem(STORAGE_KEY, v);
    };

    return { lastCat, setLastCat: setAndStore };
}

export { STORAGE_KEY };
